import { CHARACTER_MODERATION_STATUS } from "@next-platform/client-common-core";

class TextStyes {
  dropdown = {
    base: {
      content: "p-0",
    },
    menu: {
      base: "p-0 py-2 mb-0 w-[250px]",
      list: "gap-0 mb-0",
    },
    section: {
      base: "mb-0",
      divider: "mb-2",
    },
    item: {
      base: "mx-2 w-[calc(100%-1)] p-0 min-h-[36px] py-1.5",
      title: "text-[16px] px-3 flex *:grow",
      description: "text-gray-800 px-3",
    },
    item_primary: {
      base: "data-[hover=true]:bg-secondaryLightHover data-[hover=true]:text-secondaryLightContrast mx-2 w-[calc(100%-1)] p-0 min-h-[36px] tracking-tighter py-1.5",
      title: "text-[16px] px-3 flex *:grow",
      description: "text-gray-800 px-3",
    },
    item_danger: {
      base: "data-[hover=true]:bg-danger-50 mx-2 w-[calc(100%-1)] p-0 min-h-[36px] tracking-tighter py-1.5",
      title: "text-[16px] px-3 flex *:grow",
      description: "text-gray-800 px-3",
    },
  };

  pagination = {
    item: "cursor-pointer",
    prev: "cursor-pointer",
    next: "cursor-pointer",
    cursor: "text-white font-bold",
  };

  navbar = {
    menu: {
      base: "navbar-menu z-[100001] -mt-[12px] list-none gap-0 h-full p-0 first:pt-[22px]",

      item: "py-1.5 px-6 bg-white dark:bg-black first:pt-4 last:pb-7",

      link: "cursor-pointer text-lg",
    },
  };

  blackFriday = {
    title: "!text-white max-w-[300px] text-center text-[18px] ml-[9%] [text-shadow:1px_0px_10px_#fff]",
    subTitle: "text-center text-[12px] mb-8 ml-[9%] [text-shadow:1px_0px_10px_#fff] text-white",
    discount: "text-center text-[50px] leading-[40px] [text-shadow:1px_0px_10px_#fe46c5] text-[#9669c3]",
    button:
      "font-[Roboto] bg-transparent border-3 border-solid border-[#8396c8] rounded-[25px] text-[#8f40ea] shadow-[0 0 10px #8396c8, inset 0 0 5px white] text-[15px] py-[8px] pb-4 px-[17px] outline-none font-bold drop-shadow-[#8f40ea 1px 0 10px] px-2.5 no-underline",
  };

  accordion = {
    heading: "m-0",
    trigger: "bg-transparent cursor-pointer font-semibold min-h-12",
    title: "tracking-tighter",
    indicator: "text-[20px] data-[open=true]:rotate-90 -rotate-90",
  };

  footer = {
    links: {
      social: "flex items-center px-5 h-10",
    },
  };

  spinner = "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-150";

  moderationStyles(moderationStatus) {
    let moderationBorder;
    let moderationColor;
    switch (moderationStatus) {
      case CHARACTER_MODERATION_STATUS.FIX_REQUIRED:
        moderationBorder = "border-colorFixRequired";
        moderationColor = "fix_required";
        break;
      case CHARACTER_MODERATION_STATUS.PENDING:
      case CHARACTER_MODERATION_STATUS.REREVIEW_REQUIRED:
        moderationBorder = "border-colorUnderReview";
        moderationColor = "under_review";
        break;
      case CHARACTER_MODERATION_STATUS.MANUAL_REVIEW_REQUIRED:
        moderationBorder = "border-red-8";
        moderationColor = "manual_review_required";
        break;
      default:
        moderationBorder = "";
        moderationColor = "";
        break;
    }
    return {
      moderationBorder,
      moderationColor,
    };
  }
}

const TextStyles = new TextStyes();

export default TextStyles;
